export default __webpack_public_path__ + "static/media/bus-short-distance.36b99634.svg";